<template>
  <div class="wrapper">
     <div class="item" @click="linkTo('editInfo')">
       <span>个人信息</span>
       <img src="./../../assets/images/index/img_back.png" alt class="back" />
     </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      info:{

      },
    }
  },
  methods: {
    linkTo(url){
      this.$router.push({path:'/'+ url,query:{supNbr:this.userInfo.nbr}});
    }
  },
  mounted() {
    document.title = '设置'
  },
}
</script>

<style scoped lang='less'>
.wrapper{
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}
.topHead{
  width: 100%;
  height: 1.36rem;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 .24rem;
  box-sizing: border-box;
  justify-content: space-between;
}
.pic{
  width: .96rem;
  height: .96rem;
  border-radius: 50%;
  margin-right: .29rem;
}
.topHead span{
  font-size: .3rem;
  color: #333333;
  font-weight: 500;
}
.topHead .back{
  width: 0.44rem;
  height: 0.44rem;
}
.item{
  height: .98rem;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 0 .24rem;
  box-sizing: border-box;
  justify-content: space-between;
  span{
    font-size: .3rem;
    color: #333;
    font-weight: 500;
  }
  input{
    font-size: .3rem;
    color: #333;
    font-weight: 500;
    border: none;
    flex: 1;
    margin-left: .2rem;
    text-align: right;
  }
  .back{
    width: 0.44rem;
    height: 0.44rem;
  }
}
.btn{
  position: absolute;
  bottom: .32rem;
  left: 50%;
  transform: translateX(-50%);
  width: 6.88rem;
  height: 0.88rem;
  border-radius: .04rem;
  background: #FF3B30;
  display: flex;
  justify-content: center;
  align-items: center;
  span{
    font-size: 0.3rem;
    color: #fff;
    font-weight: 500;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/information/setting.vue